// extracted by css-extract-rspack-plugin
export default {"sales-app-wrapper":"src-modules-app-registry-components-SalesApp-SalesApp-module__sales-app-wrapper-Zv85Fw","salesAppWrapper":"src-modules-app-registry-components-SalesApp-SalesApp-module__sales-app-wrapper-Zv85Fw"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"sales-app-wrapper\":\"src-modules-app-registry-components-SalesApp-SalesApp-module__sales-app-wrapper-Zv85Fw\",\"salesAppWrapper\":\"src-modules-app-registry-components-SalesApp-SalesApp-module__sales-app-wrapper-Zv85Fw\"}";
        // 1793873545935
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  